<template>
  <div class="home-furusato">
    <div class="inner">
      <h2 class="furusato-title">
        <img
          src="@/assets/RI_20260826-01.svg"
          alt=""
          class="furusato-title__icon"
        />
        <span class="furusato-title__text"
          >企業版ふるさと納税を通じて、<br class="furusato-title__br" />故郷・岡山県高梁市へ恩返し</span
        >
      </h2>

      <div class="furusato-movie">
        <iframe
          src="https://player.vimeo.com/video/1220697000?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="RCIふるさと納税"
        ></iframe>
      </div>

      <p class="furusato-text">
        当社代表・川上の故郷である旧岡山県川上郡川上町（現在の高梁市）へ、今回初めて企業版ふるさと納税による寄付を行い、高梁市長にご出席いただき受納式を執り行っていただきました。企業版ふるさと納税を通じて、故郷に恩返しができることを大変嬉しく思っております。<br />
        今回の寄付が、地域の皆様のお役に少しでも立つことができれば、これほど嬉しいことはありません。今回いただいたご縁を大切にし、今後も一企業として、また一個人として、微力ではございますが、地域の発展に貢献してまいりたいと考えております。
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const VIMEO_PLAYER_API = "https://player.vimeo.com/api/player.js";

export default {
  name: "HomeFurusato",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  mounted() {
    if (document.querySelector(`script[src="${VIMEO_PLAYER_API}"]`)) return;
    const script = document.createElement("script");
    script.src = VIMEO_PLAYER_API;
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>

<style lang="scss" scoped>
.home-furusato {
  background-color: var(--main);
  padding: 100px 20px;

  @media screen and (max-width: 767px) {
    padding: 40px 20px 45px;
  }
}

.inner {
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0 auto;
}

.furusato-title {
  display: flex;
  align-items: center;
  gap: 30px;
  font-size: 24px;
  line-height: 1.5em;

  @media screen and (max-width: 767px) {
    justify-content: space-between;
    gap: 10px;
    font-size: 22px;
  }

  //端末幅が狭いときも、デザイン通りの2行組みを保てるところまで縮める
  @media screen and (max-width: 419px) {
    font-size: 5.2vw;
  }

  &__br {
    display: none;

    @media screen and (max-width: 767px) {
      display: inline;
    }

    //2行に収めきれない幅では、改行指定を外して自然に折り返させる
    @media screen and (max-width: 369px) {
      display: none;
    }
  }

  &__icon {
    flex-shrink: 0;
    width: 48px;

    @media screen and (max-width: 767px) {
      order: 2;
    }
  }
}

.furusato-movie {
  margin-top: 25px;
  position: relative;
  padding-top: 56.25%;

  @media screen and (max-width: 767px) {
    order: 3;
    margin-top: 20px;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.furusato-text {
  margin-top: 40px;
  font-size: 16px;
  line-height: 2.06em;
  color: #fff;

  @media screen and (max-width: 767px) {
    order: 2;
    margin-top: 10px;
  }
}
</style>
